// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TyJ2V6exQb_nUzka9zNj {
  display: flex;
  align-items: flex-start;
}

.fli4TxEMb9iCHnYPHhyj {
  margin-top: 0.1875rem;
  margin-right: 0.5rem;
  min-width: 1.25rem;
  min-height: 1.25rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomErrorMessage/CustomErrorMessage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,qBAAe;EACf,oBAAiB;EACjB,kBAAe;EACf,mBAAgB;AAClB","sourcesContent":[".container {\n  display: flex;\n  align-items: flex-start;\n}\n\n.icon {\n  margin-top: 3px;\n  margin-right: 8px;\n  min-width: 20px;\n  min-height: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TyJ2V6exQb_nUzka9zNj`,
	"icon": `fli4TxEMb9iCHnYPHhyj`
};
export default ___CSS_LOADER_EXPORT___;
